// Read-only definition of one datasheet label, opened by clicking a label on a datasheet preview.
//   scope 'master'  — the master definition.
//   scope 'project' — this database's override when it has one, else the master.
// Definitions are written on the composer's Definitions tab, not here.
import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { dsDefinitionsApi } from '../../services/api';
import { StuiRichTextViewer } from '../../components/common/StuiRichText';
import { normalizeLabel, shownDefinition, definitionError } from './dsDefinitions';

export default function DefinitionModal({ label, scope = 'master', onClose }) {
  const [state, setState] = useState({ loading: true, read: null, error: null });

  useEffect(() => {
    let live = true;
    setState({ loading: true, read: null, error: null });
    dsDefinitionsApi[scope].get(normalizeLabel(label))
      .then(r => live && setState({ loading: false, read: r.data, error: null }))
      .catch(e => live && setState({ loading: false, read: null, error: definitionError(e, 'Failed to load the definition.') }));
    return () => { live = false; };
  }, [label, scope]);

  const shown = scope === 'project'
    ? shownDefinition(state.read)
    : { kind: state.read?.master ? 'master' : 'none', def: state.read?.master };

  return (
    <div className="stui-modal-overlay" onClick={onClose}>
      <div className="stui-modal stui-modal-md" onClick={e => e.stopPropagation()}>
        <div className="stui-modal-header">
          <span className="stui-modal-title">{normalizeLabel(label)}</span>
          <button className="stui-modal-close" onClick={onClose} title="Close"><X size={20} /></button>
        </div>
        <div className="stui-modal-body">
          {state.loading ? (
            <p className="stui-label-note">Loading…</p>
          ) : state.error ? (
            <p className="stui-label-note">{state.error}</p>
          ) : shown.kind === 'none' ? (
            <p className="stui-label-note">No definition yet. Definitions are written on the Definitions tab.</p>
          ) : (
            <>
              {shown.kind === 'override' && <p className="stui-hint">This database's definition (overrides the master).</p>}
              <StuiRichTextViewer html={shown.def.contentHtml} />
            </>
          )}
        </div>
        <div className="stui-modal-footer">
          <button className="stui-btn stui-btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
